const THEME_STORAGE_KEY = 'theme_key';

export { THEME_STORAGE_KEY };